

































import Vue from 'vue'
import Component from 'vue-class-component';
import { PageTitle } from '@questelservices/common-vue';
import ClientDataGrid from '../components/client-data-grid.vue';
import { ClientMatterDataService } from '../service/ClientMatterDataService';
import { DxColumn, DxEditing, DxStateStoring } from 'devextreme-vue/data-grid';

@Component({
  components: {
    PageTitle,
    ClientDataGrid,
    DxColumn,
    DxEditing,
    DxStateStoring
  }
})
export default class ClientMatterData extends Vue {}
